export const API_ENDPOINTS = {
  GET_AUTH_TOKEN: '/accounts/auth/v1/access-token',
  REVOKE_AUTH_TOKEN: '/accounts/auth/v1/logout',
  SAVE_DEVICE_ID: '/crypto-wallet/v1/user'
}
